import { useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "../../../utils/hooks/translateHook.js";
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";
import { transformLevelContent } from "../../../utils/transformLevelContent.js";
import { hasAccess } from "../../../utils/permissions.js";
import { slugify } from "../../../utils/slugify.js";
import { videoTitle } from "../../../utils/titles.js";
import { courseRegistry } from "../../../courses/courseRegistry.js";
import videoArrow from "../../../images/icons/videoArrow.svg";

const VideosTree = ({ user }) => {
  const { courseSlug } = useParams();
  const navigate = useNavigate();
  const t = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const courseConfig = courseRegistry[courseSlug];
  const translatedData = useLevelContentData( courseConfig?.levelContentData || [], courseSlug) || [];
  const transformedData = useMemo(
    () => transformLevelContent(translatedData) || [],
    [translatedData]
  );

  const accessibleLevels = useMemo(() => {
    return transformedData
      .filter((item) => hasAccess(user, item.level, courseSlug) && item.level !== 9999)
      .sort((a, b) => a.level - b.level);
  }, [transformedData, user, courseSlug]);

  const accessibleSubjects = useMemo(() => {
    return accessibleLevels.flatMap(
      (level) => level.subjects || []
    );
  }, [accessibleLevels]);

  const handleVideoClick = (filename) => {
    const slug = slugify(filename);
    navigate( `/course/${courseSlug}/videos/${slug}`);
  };

  return (
    <div className="video-tree-back">
      <div className="video-tree-box">
        <div className="video-mobile-tree">
          <h4 className="video-sidebar-title">
            <span>
              {t("video_courses").toUpperCase()}
            </span>
            <img src={videoArrow} alt="" className="video-sidebar-arrow"/>
          </h4>
          {accessibleSubjects.map((subject, idx) => (
            <div key={idx} className="video-mobile-subject">
              <div className="video-mobile-subject-title"
                onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
              >
                {subject.title.toUpperCase()}
              </div>

              {openIndex === idx &&
                Array.isArray(subject.videos) && (
                  <div className="video-mobile-lessons">
                    {subject.videos.map(
                      (filename, videoIdx) => (
                        <button  className="video-mobile-lesson"
                          key={videoIdx}
                          type="button"
                          onClick={() => handleVideoClick(filename)}
                        >
                          {videoTitle(filename).replace( /^\d+(\.\d+)*\.\s*/, "")
                            .toUpperCase()}
                        </button>
                      )
                    )}
                  </div>
                )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VideosTree;